<script lang="ts">
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { format } from '../../../../services/i18n';
	import { postReq } from '../../../../services/http';
	//Helpers
	import { copy } from '../../../../helpers/copy_text';
	//Design system components
	import { Button, IconButton, Text, Alert, toast } from '@Shelly/shelly-design-system';

	let authKeyHolder = '';
	let show = false;

	const shown = () => {
		show = true;
		handleAuthKey();
	};

	//GET AUTH KEY ----------------------------------------------------------------------------------
	export const handleAuthKey = async () => {
		let res = await postReq('/user/get_user_key', {});
		if (res.isok) {
			authKeyHolder = res.data.key.toString();
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
</script>

{#if show}
	<Alert class="mb-s" heading={`Server: ${$user_data.user_api_url}`} />
	<div class="d-flex align-items-center">
		<Text styleType="body-small" breakWord>{authKeyHolder}</Text>
		<IconButton
			aria-label={$format('button_copy_to_clipboard', { default: 'Copy to clipboard' })}
			class="ml-s"
			icon={'fas fa-copy'}
			on:click={() => copy(authKeyHolder, $format('copy_to_clippboard'))}
		/>
	</div>
{:else}
	<Button size="m" class="width-md-auto width-sm-full" width="s" on:click={shown}
		>{$format('get_key')}</Button
	>
{/if}
